import React from "react";
import { Link } from "react-router-dom";
import styles from "./Header.module.css";
import Burger from "./Burger";
import logo from "../../Images/Logo/White Background .png";
import text from "../../Images/Logo/IceGemsText.png";

const HeaderOld: React.FC = () => {
  return (
    <header className={styles.header}>
      <div className={styles.logo}>
        <Link to={"/"}>
          <img
            loading="lazy"
            src={logo}
            className={styles.logoImage}
            alt="Ice Gems logo"
          />
          <img
            loading="lazy"
            src={text}
            className={styles.logoImage}
            alt="Ice Gems logo"
          />
        </Link>
      </div>
      <Burger />
    </header>
  );
};

export default HeaderOld;
